(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/lb-utils/sport-products/assets/javascripts/get-active-extratipset-name.js') >= 0) return;  svs.modules.push('/components/lb-utils/sport-products/assets/javascripts/get-active-extratipset-name.js');
"use strict";


let getCmsConfig;
let tipsenShared;
let dateFnsInstance;
if (svs.isServer) {
  getCmsConfig = require('../../../get-cms-config/assets/javascripts/utils.es6').getCmsConfig;
  tipsenShared = require('../../../../sport/tipsen-shared/assets/javascripts/tipsen-shared.es6');
  dateFnsInstance = require('@svenskaspelab/trinidad-core').core.components.require('libs', 'date-fns').api;
} else {
  getCmsConfig = svs.components.lbUtils.getCmsConfig.utils.getCmsConfig;
  tipsenShared = svs.components.sport.tipsenShared;
  dateFnsInstance = dateFns;
}
const _tipsenShared = tipsenShared,
  getSubProductDisplayName = _tipsenShared.getSubProductDisplayName,
  userProduct2SubProductId = _tipsenShared.userProduct2SubProductId;
const _dateFnsInstance = dateFnsInstance,
  isValid = _dateFnsInstance.isValid,
  isWithinInterval = _dateFnsInstance.isWithinInterval,
  parseISO = _dateFnsInstance.parseISO;
const getActiveExtratipsetName = () => {
  var _getCmsConfig;
  const config = (_getCmsConfig = getCmsConfig()) === null || _getCmsConfig === void 0 ? void 0 : _getCmsConfig.extratipset;
  if (!config) {
    return null;
  }
  const active = config.active,
    productName = config.productName,
    startDate = config.startDate,
    stopDate = config.stopDate;
  if (active !== 'on' || !productName || !startDate || !stopDate) {
    return null;
  }
  const start = parseISO(startDate);
  const end = parseISO(stopDate);
  const now = new Date();
  if (!isValid(start) || !isValid(end) || start > end) {
    return null;
  }
  if (isWithinInterval(now, {
    start,
    end
  })) {
    const subProductId = userProduct2SubProductId[productName];
    return subProductId ? getSubProductDisplayName(subProductId) : null;
  }
  return null;
};
if (svs.isServer) {
  module.exports = getActiveExtratipsetName;
} else {
  setGlobal('svs.components.lbUtils.sportProducts', {
    getActiveExtratipsetName
  });
}

 })(window);